import { useEffect, useState } from "react";
import UserFilters from "../UserFilters.jsx";
import { getCompanyList } from "../../../api/users.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Heading from "../../../components/Heading.jsx";
import CompanyTable from "../CompanyTable.jsx";

function CompaniesList() {
    
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);

    const genderFilters = [
        { value: 'male', placeholder: 'Male', },
        { value: 'female', placeholder: 'Female', },
        { value: 'other', placeholder: 'Other', }
    ];
    const ageGroupFilters = [
        { value: 'kid', placeholder: 'Kid' },
        { value: 'adult', placeholder: 'Adult' },
        { value: 'old', placeholder: 'Old' },
    ];
    const userActiveFilters = [
        { value: true, placeholder: 'Active' },
        { value: false, placeholder: 'Inactive' },
    ];
      
    const [filters, setFilters] = useState([
        { label: 'Company Name', placeholder: 'Enter Company Name', name: 'name', value: '', type: 'text' },
        { label: 'Email', placeholder: 'Enter Email', name: 'email', value: '', type: 'email' },
        { label: 'From Date', placeholder: 'Select From Date', name: 'fromDate', value: '', type: 'date' },
        { label: 'To Date', placeholder: 'Select To Date', name: 'toDate', value: '', type: 'date' },
        { label: "Status", placeholder: "Choose Status", data: userActiveFilters, name: 'active', value: '', type: 'select' },
    ]);

    const filterUsers = () => {
        const activeFilters = filters.filter(f => f.value);
        const result = users.filter(user => {
            return activeFilters.every(filter => {
                const filterValue = filter.value;
                const userValue = user[filter.name];
                
                // Handle text fields (companyName, email) with case-insensitive partial matching
                if (filter.type === 'text' || filter.type === 'email') {
                    return userValue && userValue.toLowerCase().includes(filterValue.toLowerCase());
                }
                
                // Handle date range filtering for createdAt
                if (filter.name === 'fromDate') {
                    const userDate = new Date(user.createdAt);
                    const fromDate = new Date(filterValue);
                    return userDate >= fromDate;
                }
                
                if (filter.name === 'toDate') {
                    const userDate = new Date(user.createdAt);
                    const toDate = new Date(filterValue);
                    // Add 24 hours to include the entire "to" date
                    toDate.setHours(23, 59, 59, 999);
                    return userDate <= toDate;
                }
                
                // Handle exact matching for select fields
                if (filter.type === 'select') {
                    return userValue === filterValue;
                }
                
                // Default fallback
                return userValue === filterValue || (typeof filterValue === 'string' && filterValue.match && filterValue.match(userValue));
            });
        });
        setFilteredUsers(result);
    };

    const clearFilters = () => {
        const resetFilters = filters.map(filter => ({ ...filter, value: '' }));
        setFilters(resetFilters);
        setFilteredUsers(users);
    }
    
    useEffect(() => {
        getCompanyList((data) => {
            // Extract companies array from pagination response
            const companiesArray = data?.companies || [];
            setUsers(companiesArray);
            setFilteredUsers(companiesArray);
        }, toast);
    }, []);
    
    return (
        <main className="flex flex-col text-sm font-semibold text-gray-900 rounded-none">
            <Heading
                text={"All Companies"}
            />
            <UserFilters
                filters={filters}
                setFilters={setFilters}
                filterUsers={filterUsers}
                clearFilters={clearFilters}
            />
            <section className="flex flex-col pt-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                    <h1 className="self-start text-base font-semibold">Company Data List</h1>
                    <CompanyTable users={filteredUsers} toast={toast} />
                </div>
            </section>
            <ToastContainer 
                position = "top-right"
                autoClose={1000}
            />
        </main>
    );
}

export default CompaniesList;